import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=ae149c76&scoped=true&"
import script from "./ClientForm.vue?vue&type=script&lang=js&"
export * from "./ClientForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=ae149c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae149c76",
  null
  
)

export default component.exports